/**
 * 订单表单弹窗「活动信息」区块：对接人、对接电话、活动名称与地址（默认收起，点击展开）
 */
import type { Dispatch, SetStateAction } from 'react';
import { Controller, type Control, type FieldErrors } from 'react-hook-form';
import type { OrderFormData } from '../../OrderFormSchema';
import { inp, lbl } from '../utils';

interface ActivitySectionProps {
  control: Control<OrderFormData>;
  errors: FieldErrors<OrderFormData>;
  showActivity: boolean;
  setShowActivity: Dispatch<SetStateAction<boolean>>;
}

export function ActivitySection({ control, errors, showActivity, setShowActivity }: ActivitySectionProps) {
  return (
    /* ④ 活动信息（默认收起，点击展开） */
    <div>
      <button
        type="button"
        onClick={() => setShowActivity(!showActivity)}
        className="w-full flex items-center justify-between py-3 px-4 rounded-xl bg-gray-50 hover:bg-gray-100 transition-colors cursor-pointer"
      >
        <div className="flex items-center gap-2.5">
          <div className="w-7 h-7 flex items-center justify-center rounded-lg bg-orange-50 text-orange-400">
            <i className="ri-map-pin-line text-sm" />
          </div>
          <span className="text-sm font-semibold text-gray-700">活动信息</span>
          <span className="text-xs text-gray-400">（选填）</span>
          {/* 收起状态下也要能看见「这一里有错」，否则提交被挡却找不到是哪格 */}
          {!showActivity && errors.contactPhone && (
            <span className="text-xs text-rose-500"><i className="ri-error-warning-line mr-0.5" />{errors.contactPhone.message}</span>
          )}
        </div>
        <i className={`ri-arrow-down-s-line text-gray-400 text-lg transition-transform ${showActivity ? 'rotate-180' : ''}`} />
      </button>
      {showActivity && (
        <div className="mt-3 space-y-4 px-1">
          <div className="grid grid-cols-2 gap-3">
            <div>
              <label className={lbl}>对接人</label>
              <Controller
                name="contactPerson"
                control={control}
                render={({ field }) => (
                  <input
                    type="text"
                    {...field}
                    placeholder="现场对接人姓名"
                    className={inp()}
                  />
                )}
              />
            </div>
            <div>
              <label className={lbl}>对接电话</label>
              <Controller
                name="contactPhone"
                control={control}
                render={({ field }) => (
                  <input
                    type="tel"
                    {...field}
                    placeholder="对接人手机号"
                    className={inp(errors.contactPhone?.message)}
                  />
                )}
              />
              {errors.contactPhone && <p className="text-xs text-rose-500 mt-1">{errors.contactPhone.message}</p>}
            </div>
          </div>
          <div>
            <label className={lbl}>活动名称</label>
            <Controller
              name="activityName"
              control={control}
              render={({ field }) => (
                <input
                  type="text"
                  {...field}
                  placeholder="活动主题或名称"
                  className={inp()}
                />
              )}
            />
          </div>
          <div>
            <label className={lbl}>活动地址</label>
            <Controller
              name="activityAddress"
              control={control}
              render={({ field }) => (
                <input
                  type="text"
                  {...field}
                  placeholder="详细活动地点"
                  className={inp()}
                />
              )}
            />
          </div>
        </div>
      )}
    </div>
  );
}